module.exports = __webpack_public_path__ + "img/State=17.886ca432.svg";